import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import MakeDiscountCodeButton from "./MakeCommentButtonManage";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";

import ItemsSkeleton from "../../../components/loaders/ItemsSkeleton";
import ListFilters from "../lists/filters/ListFilters";
import {useTranslation} from "react-i18next";
import DiscountCodeCard from "./components/CommentCard";
import {Link, useNavigate} from "react-router-dom";
import {Pagination} from "@mui/lab";
import Title from "../../../components/elements/Title";
import {scrollTop} from "../../../../config/values";
import {Typography} from "@mui/material";
import {ChevronLeft, MessageCircleOff, PackageOpen} from "lucide-react";
import Button from "@mui/material/Button";
import NothingFound from "../../../components/elements/NothingFound";
import CommentCard from "./components/CommentCard";

function CommentsPage(){
    const { t } = useTranslation();
    const [items, setItems] = useState([]);
    const [filters, setFilters] = useState({});
    const [pages, setPages] = useState(1);
    const [current_page, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();

    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        let url = `${defaultVariables.url}/comments/get-all?page=${current_page}${!!filters.text ? "&search="+filters.text : ""}${!!filters.industry ? "&industry="+filters.industry : ""}`;
        axios.get(url,config)
            .then(response => {
                setItems(response.data.data);
                setPages(response.data.last_page);
                setCurrentPage(response.data.current_page);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        scrollTop();
        loadData();
    },[current_page]);

    useEffect(() => {
        scrollTop();
        loadData();
    },[filters]);

    const handleChange = (event, value) => {
        setCurrentPage(value);
    };
    const handleFilter = (filters) => {
        setFilters(filters);
    }
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageComments')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('manageComments')}</Title>
                </Grid>
                {
                    !!loading ?
                        <>
                            <ItemsSkeleton height={100} xs={12} md={12} lg={12} length={1}/>
                            <ItemsSkeleton height={300} xs={12} md={6} lg={4}/>
                        </>
                        :
                        <>
                            <Grid item size={12}>
                                <ListFilters
                                    filters={['search','industries','all']}
                                    onFilter={handleFilter}
                                />
                            </Grid>
                            {
                                items.length > 0 ?
                                    <Grid item size={{xs:12}} >
                                        <Grid container spacing={2} justify="center" >
                                            {
                                                items.map((item,index) =>(
                                                    <Grid item size={{xs:12,md:6,lg:4}} key={item.id}>
                                                        <CommentCard item={item} reload={() => loadData()}/>
                                                    </Grid>
                                                ))
                                            }
                                        </Grid>
                                    </Grid>
                                    :
                                    <Grid item size={{xs:12}}>
                                        <NothingFound
                                            type="page"
                                            title={t('noItemFound')}
                                            title_color="text"
                                            paragraph={t('noItemFoundHere')}
                                            icon={<MessageCircleOff/>}
                                        />
                                    </Grid>

                            }

                            {
                                pages > 1 &&
                                <Grid item size={12}>
                                    <Pagination
                                        shape="rounded"
                                        count={pages}
                                        page={current_page}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            }

                        </>
                }
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(CommentsPage);
